import { EntityDefinition } from '@/types/crud';

export const navigationScreenEntity: EntityDefinition = {
  name: 'navigation-screen',
  displayName: 'Navigation Screens',
  displayNameSingular: 'Navigation Screen',
  apiEndpoint: '/navigation/screens',

  idField: 'id',
  nameField: 'display_name',
  fields: [
    {
      key: 'screen_code',
      label: 'Screen Code',
      type: 'text',
      required: true,
      placeholder: 'Enter screen code (e.g., USER_MANAGEMENT)',
      hidden: true, // Hide from table display
      validation: {
        minLength: 2,
        maxLength: 50,
        pattern: '^[A-Z_]+$'
      }
    },
    {
      key: 'display_name',
      label: 'Display Name',
      type: 'text',
      required: true,
      placeholder: 'Enter display name',
      validation: {
        minLength: 2,
        maxLength: 100
      }
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      placeholder: 'Enter screen description',
      validation: {
        maxLength: 500
      }
    },
    {
      key: 'module_id',
      label: 'Module',
      type: 'select',
      required: true,
      placeholder: 'Select module',
      options: [], // Will be populated dynamically
      render: (value: any, _item: any) => {
        // This will be handled by the NavigationManagementPage with dynamic options
        return value || 'No Module';
      }
    },
    {
      key: 'route_path',
      label: 'Route Path',
      type: 'text',
      required: true,
      placeholder: 'Enter route path (e.g., /users)',
      validation: {
        minLength: 1,
        maxLength: 255,
        pattern: '^/[a-zA-Z0-9/-]*$'
      }
    },
    {
      key: 'icon',
      label: 'Icon',
      type: 'text',
      required: false,
      placeholder: 'Enter icon name (e.g., users)',
      hidden: true, // Hide from table display
      validation: {
        maxLength: 50
      }
    },
    {
      key: 'sort_order',
      label: 'Sort Order',
      type: 'number',
      required: true,
      placeholder: 'Enter sort order',
      defaultValue: 0,
      hidden: true, // Hide from table display
      validation: {
        min: 0
      }
    },
    {
      key: 'is_active',
      label: 'Active',
      type: 'boolean',
      required: true,
      defaultValue: true
    },
    {
      key: 'sidebar_menu_visibility',
      label: 'Sidebar Menu Visibility',
      type: 'select',
      required: true,
      defaultValue: 'NONE',
      options: [
        { value: 'NONE', label: 'None' },
        { value: 'USER', label: 'User' },
        { value: 'ADMIN', label: 'Admin' }
      ],
      description: 'USER = show in user sidebar; ADMIN = admin context; NONE = do not show.'
    },
    {
      key: 'is_system_screen',
      label: 'System Screen',
      type: 'boolean',
      required: false,
      defaultValue: false,
      hidden: true // Hide from table display
    },
    {
      key: 'is_public',
      label: 'Public Screen',
      type: 'boolean',
      required: false,
      defaultValue: false,
      description: 'If enabled, this screen is accessible to all authenticated users without RBAC permission check'
    }
  ],
  tableColumns: [
    { key: 'screen_code', label: 'Screen Code', sortable: true },
    { key: 'display_name', label: 'Display Name', sortable: true },
    { key: 'description', label: 'Description', sortable: false },
    { key: 'route_path', label: 'Route Path', sortable: true },
    { key: 'sidebar_menu_visibility', label: 'Sidebar Menu Visibility', sortable: true },
    { key: 'sort_order', label: 'Sort Order', sortable: true },
    { key: 'is_active', label: 'Active', sortable: true },
    { key: 'is_public', label: 'Public', sortable: true },
    { 
      key: 'created_at', 
      label: 'Created', 
      sortable: true,
      render: (value: string) => {
        if (!value) return '';
        const date = new Date(value);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      }
    }
  ],
  searchFields: ['screen_code', 'display_name', 'description', 'route_path'],
  defaultSort: { field: 'sort_order', direction: 'asc' },
  copyable: true,
  deletable: false,
  customActions: [
    {
      key: 'toggle_status',
      action: 'toggle_status',
      label: 'Toggle Status',
      icon: 'EyeIcon',
      variant: 'secondary',
      onClick: () => {}
    },
    {
      key: 'hard_delete',
      action: 'hard_delete',
      label: 'Hard Delete',
      icon: 'TrashIcon',
      variant: 'danger',
      onClick: () => {}
    }
  ]
};
